import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

export default function ConfirmDialog({ open, onClose, onConfirm, title = 'Conferma eliminazione', message = 'Sei sicuro di voler eliminare questo elemento? Questa azione non puo essere annullata.', confirmText = 'Elimina', variant = 'destructive' }) {
  return (
    <Dialog open={open} onOpenChange={v => { if (!v) onClose(); }}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base">
            <AlertTriangle className="w-5 h-5 text-red-500" />{title}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600">{message}</p>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onClose} data-testid="confirm-cancel">Annulla</Button>
          <Button variant={variant} onClick={() => { onConfirm(); onClose(); }} data-testid="confirm-ok" className={variant === 'destructive' ? 'bg-red-600 hover:bg-red-700' : ''}>
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
